import { render, staticRenderFns } from "./ConfirmEmailView.vue?vue&type=template&id=c4d63838&"
import script from "./ConfirmEmailView.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports